function Dd7Service($http, AppSettings, Upload) {
  'ngInject';

  const service = {};
  const basePath = function(orgId) {
    return AppSettings.apiUrl + '/organizations/' + orgId + '/dd7';
  };

  // Settings
  service.getSettings = function(orgId, callback) {
    $http.get(basePath(orgId) + '/settings').then(
      function(response) { callback(response); },
      function(response) { callback(response); }
    );
  };

  service.saveSettings = function(orgId, settings, callback) {
    $http.put(basePath(orgId) + '/settings', settings).then(
      function(response) { callback(response); },
      function(response) { callback(response); }
    );
  };

  // Xero Accounts
  service.getXeroAccounts = function(orgId, callback) {
    $http.get(basePath(orgId) + '/accounts').then(
      function(response) { callback(response); },
      function(response) { callback(response); }
    );
  };

  // Accrual Runs
  service.getAccrualRuns = function(orgId, params, callback) {
    $http.get(basePath(orgId) + '/accrual_runs', { params: params }).then(
      function(response) { callback(response); },
      function(response) { callback(response); }
    );
  };

  service.getAccrualRun = function(orgId, runId, callback) {
    $http.get(basePath(orgId) + '/accrual_runs/' + runId).then(
      function(response) { callback(response); },
      function(response) { callback(response); }
    );
  };

  service.postToXero = function(orgId, runId, callback) {
    $http.post(basePath(orgId) + '/accrual_runs/' + runId + '/post').then(
      function(response) { callback(response); },
      function(response) { callback(response); }
    );
  };

  service.retry = function(orgId, runId, callback) {
    $http.post(basePath(orgId) + '/accrual_runs/' + runId + '/retry').then(
      function(response) { callback(response); },
      function(response) { callback(response); }
    );
  };

  service.repost = function(orgId, runId, callback) {
    $http.post(basePath(orgId) + '/accrual_runs/' + runId + '/repost').then(
      function(response) { callback(response); },
      function(response) { callback(response); }
    );
  };

  // Fetch from Amazon SP-API
  service.fetchFromAmazon = function(orgId, params, callback) {
    $http.post(AppSettings.apiUrl + '/organizations/' + orgId + '/deferred_transactions/fetch', params).then(
      function(response) { callback(response); },
      function(response) { callback(response); }
    );
  };

  // File upload
  service.upload = function(orgId, file, callback) {
    Upload.upload({
      url: basePath(orgId) + '/upload',
      data: { file: file }
    }).then(
      function(response) { callback(response); },
      function(response) { callback(response); }
    );
  };

  // Initialize DD+7 with historical data for a specific month
  service.initialize = function(orgId, startMonth, callback) {
    $http.post(basePath(orgId) + '/initialize', { start_month: startMonth }).then(
      function(response) { callback(response); },
      function(response) { callback(response); }
    );
  };

  return service;
}

Dd7Service.$inject = ['$http', 'AppSettings', 'Upload'];

export default {
  name: 'Dd7Service',
  fn: Dd7Service
};
